import React from 'react'

const Footer = () => {
  //footer
  return (
    <footer className='text-center bg-neutral-600 bg-opacity-35 text-neutral-400 py-2'>
      <p className='text-sm'>Amazing Movie App</p>
    </footer>
)
  
}

export default Footer